<template>
  <ClearableInput
    ref="inputRef"
    :model-value="modelValue"
    v-bind="$attrs"
    class="hints-input"
    autogrow
    :readonly="readonly"
    @update:modelValue="$emit('update:modelValue', $event || '')"
  >
    <template #prepend>
      <q-icon name="img:common/icons/feedback-bubble.svg" />
    </template>
    <div
      v-if="!readonly && actualHints.length"
      class="hints q-mb-8"
    >
      <q-chip
        v-for="hint in actualHints"
        :key="hint"
        :label="hint"
        clickable
        @click="addHint(hint)"
      />
    </div>
  </ClearableInput>
</template>

<script setup>
import { ref, computed } from 'vue';

import ClearableInput from '~components/ClearableInput';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  hints: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const inputRef = ref(null);

const actualHints = computed(() => props.hints
  .filter((text) => !props.modelValue.toLowerCase().includes(text.toLowerCase())));

function addHint(hint) {
  const result = props.modelValue && `${props.modelValue}. `;
  emit('update:modelValue', `${result}${hint}`);
  inputRef.value.$el.querySelector('input, textarea').selectionStart = props.modelValue.length;
}

function resetValidation() {
  inputRef.value.$refs.inputRef.resetValidation();
}

defineExpose({
  resetValidation,
});
</script>

<style lang="scss">
.hints-input .q-field__control-container {
  flex-direction: column;
  textarea {
    max-height: 60px;
  }
}
</style>

<style scoped lang="scss">
.hints {
  margin-left: -40px;
}
</style>
